exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*  OWL CAROUSEL */\r\n.owl-demo .item {\r\n    height: 140px;\r\n    background: #acb7bf;\r\n    padding: 1rem;\r\n}\r\n\r\n.owl-demo .item * {\r\n    color: #ffffff;\r\n}\r\n\r\n.owl-demo-img .owl-item img {\r\n    height: 132px;\r\n}\r\n\r\n.owl-demo-video .item-video {\r\n    height: 300px;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null],"sourceMap":false}!./src/assets/modules/vendors/owl-carousel/owl-carousel.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null,null],"sourceMap":false}!./src/assets/modules/vendors/owl-carousel/owl-carousel.css
// module chunks = styles